/* public */
import { RouteHome } from './Public/RouteHome.js';
import { RouteParks } from './Public/RouteParks.js';
import { RouteUnivers } from './Public/RouteUnivers.js';
import { RouteHistory } from './Public/RouteHistory.js';
import { RouteArchives } from './Public/RouteArchives.js';
import { RouteFestivals } from './Public/RouteFestivals.js';
import { RouteAttractions } from './Public/RouteAttractions.js';
import { RouteCategoriesFamilies } from './Public/RouteCategoriesFamilies.js';
import { RouteFamily } from './Public/RouteFamily.js';
import { RouteCharacters } from './Public/RouteCharacters.js';
import { RouteRendezVous } from './Public/RouteRendezVous.js';
import { RouteOrigins } from './Public/RouteOrigins.js';
import { RouteOutlinks } from './Public/RouteOutlinks.js';
import { RouteExperiments } from './Public/RouteExperiments.js';

export const RouterPublic = () => {
    const uri = window.location.href;
    if (uri.includes('/admin')) return (<></>);
    /* public - il etait une fois */
    if (uri.includes('/historique')) return (<RouteHistory />);
    if (uri.includes('/archives-des-attractions')) return (<RouteArchives />);
    if (uri.includes('/archive')) return (<RouteArchives />);
    if (uri.includes('/festivals-disney')) return (<RouteFestivals />);
    /* public - personnages disney */
    if (uri.includes('/personnages')) return (<RouteCharacters />);
    if (uri.includes('/personnage')) return (<RouteCharacters />);
    if (uri.includes('/rendez-vous-personnage')) return (<RouteRendezVous />);
    if (uri.includes('/rendez-vous')) return (<RouteRendezVous />);
    /* public -classement */
    if (uri.includes('/categories-et-familles')) return (<RouteCategoriesFamilies />);
    if (uri.includes('/categorie')) return (<RouteCategoriesFamilies />);
    if (uri.includes('/films-et-series')) return (<RouteOrigins />);
    if (uri.includes('/origine')) return (<RouteOrigins />);
    if (uri.includes('/experience')) return (<RouteExperiments />);
    if (uri.includes('/liens')) return (<RouteOutlinks />);
    if (uri.includes('/famille')) return (<RouteFamily />);
    /* public - parks */
    if (uri.includes('/attraction')) return (<RouteAttractions />);
    if (uri.includes('/univers')) return (<RouteUnivers />);
    if (uri.includes('/park-disneyland')) return (<RouteParks />);
    if (uri.includes('/disney-adventure-world')) return (<RouteParks />);
    if (uri.includes('/')) return (<RouteHome />);
}